export default {
  Settings: {
    SettingsDescription: 'Contact',
    Contact: {
      Title: 'Contact',
      Copy: 'Copy',
      Delete: 'Delete',
      CreateNew: {
        Action: 'Add new contact',
        ContactType: 'Contact type',
        ContactDetail: 'Contact detail',
        ContactTypeExample: {
          Email: 'Email',
          PhoneNumber: 'Phone number',
          EmergencyContact: 'Emergency contact',
        },
      },
    },
  },
  Correspondance: {
    Title: 'Communications',
    Filter: 'Filter',
    Header: {
      Description: 'Description',
      LastAnnouncement: 'Last announcement',
    },
    Type: {
      Comments: 'Comment',
      Announcements: 'Announcements',
      Logs: 'Logs',
      CalendlyUpdate: 'Calendly Updates',
      DialpadSms: 'Dialpad SMS',
      DialpadCallTranscripts: 'Dialpad Call Transcripts',
      Emails: 'Emails',
    },
    Sort: {
      NewestFirst: 'Newest first',
      OldestFirst: 'Oldest first',
    },
    FilterPills: {
      All: 'All',
      Sms: 'SMS',
      Call: 'Call',
      Email: 'Email',
    },
    NewMessage: {
      Comments: 'Comment',
      Announcements: 'Announce',
      InternalNotes: 'Internal notes',
      SendMessage: 'Send message to',
      DraftEmail: 'email.draft',
      DraftSms: 'sms.draft',
      FromName: 'From Name',
      Cancel: 'Cancel',
      AddACommentOrAnnouncements: 'Add a comment or announcement',
      SendAnEmailOrSmsMessage: 'Send an email or SMS message',
      SendEmail: 'Send Email',
      SendSms: 'Send SMS',
      LocalSentEmail: 'Email message has been sent to #{recipientName}.',
      LocalSentSms: 'SMS message has been sent to #{recipientName}.',
      To: 'To: #{to}',
    },
    Correspondance: {
      AnnouncedOn: 'Announced on',
      CommentedOn: 'Commented on',
      CalendlyUpdate: 'Meeting updated (via Calendly)',
      DialpadSms: 'SMS message (via Dialpad)',
      DialpadCallTranscripts: 'Call transcript (via Dialpad)',
      Email: 'Email',
      ReplyBuilder: {
        SubjectPrefix: 'Re:',
        DateFormat: 'ddd, MMM D, YYYY [at] h:mm A',
        Header: 'On #{replyPrefix} wrote:',
        HeaderFallback: 'On this email wrote:',
      },
      EmailMetadata: {
        From: 'From',
        Subject: 'Subject',
        To: 'To',
        ReplyTo: 'Reply-To',
        Date: 'Date',
      },
      Logs: {
        CreatedOn: 'Created client on',
        EditName: 'Edited name on',
        EditDescription: 'Edited description on',
        EditStatus: 'Edited status on',
        EditPhoto: 'Edited photo on',
        EditContact: 'Added contact on',
        RemoveContact: 'Removed contact on',
      },
    },
    Messages: {
      LoadMore: 'Load more',
    },
    Feed: {
      Titles: {
        AnnouncementPosted: 'Announcement posted',
        CommentAdded: 'Comment added',
        CalendlyUpdate: 'Calendly update',
        SmsMessageSent: 'SMS message',
        DialpadCall: 'Dialpad call',
        EmailSent: 'Email',
        ClientCreated: 'Client created',
        NameUpdated: 'Name updated',
        StatusUpdated: 'Status updated',
        ContactAdded: 'Contact added',
        ContactRemoved: 'Contact removed',
        SituationPetrified: 'Situation petrified',
      },
      Metadata: {
        Calendly: 'Calendly',
        Sms: 'SMS',
        Call: 'Call',
        Transcript: 'Transcript',
        Email: 'Email',
        Logs: 'Logs',
      },
      RelativeTime: {
        Today: 'Today',
        Now: 'Now',
        MinutesAgo: '#{count} min ago',
        HoursAgo: '#{count} hr ago',
      },
    },
    Logs: {
      EditContact: {
        Text: `#{type} added: #{detail}`,
      },
      RemoveContact: {
        Text: `#{type} removed: #{detail}`,
      },
      EditStatus: {
        Text: `Status changed from #{oldStatus} to #{newStatus}`,
      },
      EditName: {
        Text: `Client name changed from #{oldClientName} to #{newClientName}`,
      },
      PetrifySituation: {
        Text: `Moved "#{summary}" into the long-term situation summary.`,
        FallbackText: 'Moved a situation into the long-term situation summary.',
      },
    },
  },
  Chat: {
    TabTitle: 'Chats',
    NoCaregivers: 'No caregivers are associated with this client.',
    UnknownCaregiver: 'Caregiver',
  },
  Status: {
    Subtitles: {
      Created: 'Joined: #{value}',
      Updated: 'Updated: #{value}',
      Day: 'Day #{number}',
      Days: 'Days',
      DaysInStage: 'Days in Stage',
      InStage: 'In stage: #{value}',
      SinceLastMsg: 'Last msg: #{value}',
      StartTimeline: 'Start Timeline',
      HrsPerWeek: 'Hrs/Week',
      CareRecipient: 'Care Recipient',
      CareRelationship: 'Care Relationship',
      MatchDifficulty: 'Match Difficulty',
      Relationships: 'Relationships',
      Phone: 'Phone',
      BookWithCalendly: 'Book with Calendly',
    },
    Metrics: {
      PrimaryContact: 'Primary Contact',
      ContactEmail: 'Contact Email',
      ContactPhone: 'Contact Phone',
      CalCom: 'Cal.com',
      CallType: 'Call type',
      CallTypes: {
        Intro: 'Intro call',
        Kickoff: 'Kick-off',
      },
      BookCall: 'Book call',
      IntroCall: 'Intro call',
    },
    SubtitleValue: {
      Day: '#{number} day',
      Days: '#{number} days',
      TwoWeeks: 'Two Weeks',
      FourWeeks: 'Four Weeks',
      Other: 'Other',
      Parent: '(Parent)',
      Spouse: '(Spouse)',
      Self: '(Self)',

    },
    Menu: {
      Subtitles: {
        Owner: 'Owner',
        Stage: 'Stage',
        LeadQuality: 'Lead Quality',
        CallStatus: 'Intro Call Status',
      },
      OwnerUnassigned: 'Unassigned',
    },
  },
  Situation: {
    PetrifyButton: {
      Tooltip: 'Move to long-term summary',
      AriaLabel: 'Petrify situation',
    },
    PetrifyDialog: {
      Title: 'Petrify this situation?',
      Message: 'This will move the situation into the long-term summary and remove its card. This action cannot be undone.',
      Confirm: 'Petrify',
      Petrifying: 'Petrifying...',
      Cancel: 'Cancel',
      LogMessage: 'Petrified situation: "#{summary}"',
    },
    SourceResolver: {
      ChatTitle: 'Chat conversation',
      IncompleteLink: 'The situation source link is incomplete.',
      UnknownConversation: 'The chat conversation could not be identified from this message.',
      UnlinkableSource: 'This situation source is not linkable.',
      OpenFailed: 'The situation source could not be opened.',
    },
    Subtitles: {
      Title: 'Situations (#{numberOfSituations}/10)',
      Empty: 'Client has no situations',
      LastUpdate: '– last updated #{time}',
      Expand: 'Expand',
      Collapse: 'Collapse',
    },
    Situation: {
      TriggeringSource: 'Triggering source:',
      SourceTypes: {
        COMMUNICATION_CONVERSATION_MESSAGES: 'Chat',
        CLIENT_SUPPORT_EVENT_FEEDBACK: 'Shift feedback',
        CLIENT_MESSAGE: 'Client message / Dialpad',
        CLIENT_DETAILS: 'Stage change',
      },
      Badge: {
        New: 'New',
        NewTooltip: 'New in the last #{hours} hours',
        RecentlyUpdated: 'Recently updated',
        RecentlyUpdatedTooltip: 'Recently updated in the last #{hours} hours',
      },
      Help: {
        StatusSwitch: 'This situation was created when the client changed stage. '+
        'On each status change, up to the last 25 messages since the previous status update are scanned — '+
        'including Dialpad messages, emails, and Dialpad transcripts.',
      },
      Title: 'Situation',
      UpdatedAt: 'Updated: #{time}',
      CreatedAt: 'Created: #{time}',
    },
  },
  Scheduling: {
    Title: 'Scheduling',
    AddNewSchedule: 'Add new schedule',
    ScheduleSetupWizard: 'Schedule setup wizard',
    ViewEvent: 'Viewing event',
    ViewRecurrence: 'Viewing recurrence',
    ViewLiveIn: 'Viewing live-in',
    DeleteEvent: 'Delete event',
    DeleteRecurrence: 'Delete recurrence',
    DeleteLiveIn: 'Delete live-in',
    DeleteAfterDate: 'Delete shifts after',
    DeleteAfterDateHelper: 'The shift on this date is kept, everything after it is deleted.',
    ThisReccurenceIsDeleted: 'This recurrence has been deleted',
    ScheduleDetail: {
      Action: {
        Back: 'Back',
        Next: 'Next',
        Review: 'Review',
        Create: 'Create',
      },
      SelectEventType: {
        Title: 'Event type',
        FixedEventTitle: 'Fixed Event',
        FixedEventExplain: 'Schedule this as a one-time event for a specific date and time.',
        RecurringEventTitle: 'Recurring Event',
        RecurringEventExplain: 'Set this event to repeat on a regular basis (e.g., daily, weekly, or monthly).',
        LiveInEventTitle: 'Live In Event',
        LiveInEventExplain: 'Schedule this event for all day recurring events',
      },
      EventInfo: {
        Title: 'Event name',
        Description: 'Description',
        NoDescription: 'No description',
        ShiftType: {
          Label: 'Shift type',
          Options: {
            REGULAR_CARE: 'Regular care',
            FIRST_SHIFT_LONG_TERM_CLIENT: 'First shift with long-term client',
            MEET_AND_GREET: 'Meet & greet',
            ONE_TIME_REPLACEMENT: 'One-time replacement',
            TEMPORARY_REPLACEMENT: 'Temporary replacement',
          },
        },
      },
      EventDate: {
        FixedEvent: {
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
        },
        RecurrenceEvent: {
          StartDate: 'Start date',
          EndDate: 'End date',
          EndDateDisplay: 'End date or leave blank for infinity',
          Infinity: 'Infinity',
          Frequency: 'Frequency',
          FrequencyData: {
            DAILY: 'Daily',
            WEEKLY: 'WEEKLY',
            MONTHLY: 'MONTHLY',
            YEARLY: 'YEARLY',
          },
          Interval: 'Interval',
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
          DayOfTheWeek: {
            SU: 'S',
            MO: 'M',
            TU: 'T',
            WE: 'W',
            TH: 'T',
            FR: 'F',
            SA: 'S',
          },
          ByWeekday: `By Weekday (e.g., day of the week)`,
          ByMonthDay: `By Month Day (e.g., 25)`,
          ByMonth: `By Month (e.g., 11)`,
        },
        LiveInEvent: {
          StartDate: 'Start date',
          EndDate: 'End date',
          EndDateDisplay: 'End date or leave blank for infinity',
          Infinity: 'Infinity',
          Frequency: 'Frequency',
          FrequencyData: {
            DAILY: 'Daily',
            WEEKLY: 'WEEKLY',
            MONTHLY: 'MONTHLY',
            YEARLY: 'YEARLY',
          },
          Interval: 'Interval',
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
          DayOfTheWeek: {
            SU: 'S',
            MO: 'M',
            TU: 'T',
            WE: 'W',
            TH: 'T',
            FR: 'F',
            SA: 'S',
          },
          ByWeekday: `By Weekday (e.g., day of the week)`,
        },
      },
      Breaks: {
        Title: 'Breaks',
        BreakDuration: 'Break duration',
        BreakCount: 'Break count',
      },
      Caregiver: {
        CaregiverSearch: 'Caregiver',
      },
      Recurrence: {
        RotationRecurrenceMessage: '<b>This schedule is part of a recurrence.</b><br/>Recurring instances can only be deleted by editing the source.',
        EditRecurrence: 'Edit recurrence',
      },
      LiveIn: {
        RotationLiveInMessage: '<b>This schedule is part of a live-in.</b><br/>Live-in instances can only be deleted by editing the source.',
        EditLiveIn: 'Edit live-in',
      },
    },
    Summary: {
      SummaryTitle: 'Summary',
      Hours: 'Hours: #{hours} hrs',
      HourlyRate: 'Hourly rate: $#{cost}',
      Cost: 'Total cost: $#{cost}',
    },
    Timezone: {
      Timezones: 'Timezones',
    },
  },
  CaregiverConnections: {
    Title: 'Caregivers',
    AddCaregiver: {
      Title: 'Add caregiver to roster',
      CaregiverSearch: 'Caregiver',
      AddCaregiver: 'Add caregiver',
      IncompleteProfile: 'Caregiver profile is incomplete. Missing: #{missingFields}.',
      Status: {
        Review: 'Review',
        Active: 'Active',
      },
    },
    Caregiver: {
      CaregiverName: 'Caregiver name',
      Feedback: {
        Status: {
          NotSubmitted: 'Not Yet Submitted',
          SubmittedWantsMeeting: 'Meet & Greet Requested',
          SubmittedNoMatch: 'Match Declined',
        },
        DetailsTitle: 'Feedback Details',
        ProviderName: 'Provider Name:',
        ProviderConnectionType: 'Relationship to Client:',
        SelectedOptionsTitle: 'Reasons Selected:',
        SelectedOptions: {
          SkillsAndServices: 'Skills & Services',
          Experience: 'Experience',
          Language: 'Languages',
          Location: 'Location',
          Credentials: 'Credentials',
          Personality: 'Personality',
          Other: 'Something else',
        },
        NoneProvided: 'None provided',
        AdditionalCommentsTitle: 'Additional Comments:',
      },
    },
  },
  Relationships: {
    Title: 'Relationships',
    AddRelationship: 'Add new relationship',
    EditRelationship: 'Edit relationship',
    Details: {
      Name: 'Name',
      ConnectionType: 'Connection relationship',
      Priority: 'Priority',
      Contacts: 'Contacts',
      ContactType: 'Contact type',
      ContactDetail: 'Contact detail',
      ContactTypeExample: {
        Email: 'Email',
        PhoneNumber: 'Phone',
        EmergencyContact: 'Emergency contact',
      },
      AddNewContact: 'Add new contact',
      Description: 'Description',
      NoDescription: 'No description entered',
    },
    Contacts: {
      Title: 'Contact Methods',
      NoneAdded: 'None added',
      Email: 'Email',
      Phone: 'Phone',
      Miscellaneous: 'Miscellaneous',
      MiscellaneousTypes: {
        EmergencyContact: 'Emergency contact',
      },
      Channels: {
        Authentication: 'Authentication',
        Notification: 'Notification',
        Communication: 'Communication',
        Dialpad: 'Dialpad',
      },
      ChannelTypes: {
        Email: 'Email',
        Sms: 'SMS',
      },
      Fields: {
        FirstName: 'First name',
        LastName: 'Last name',
      },
      States: {
        Setup: 'Setup',
        Active: '✔️ Active',
        Reactivate: 'Reactivate',
      },
      Dialogs: {
        Setup: {
          Title: 'Setup #{channelType} for #{channel}',
          ConfirmButton: 'Setup',
        },
        ConfirmSetup: {
          Title: 'Confirm Setup',
          Message: 'Are you sure you want to setup this user?',
          ConfirmButton: 'Setup',
        },
        ConfirmDeactivate: {
          Title: 'Confirm Deactivation',
          Message: 'Are you sure you want to deactivate this user?',
          ConfirmButton: 'Deactivate',
        },
        ConfirmReactivate: {
          Title: 'Confirm Reactivation',
          Message: 'Are you sure you want to reactivate this user?',
          ConfirmButton: 'Reactivate',
        },
        Cancel: 'Cancel',
        SmsHelperText: {
          FailRegexMessage: 'Must be a valid CAN/US number (10 or 11 digits)',
        },
      },
    },
    CreateRelationship: 'Create relationship',
    EditRelationship: 'Edit relationship',
  },
  Payment: {
    Title: 'Payment',
    PaymentPlan: {
      Title: 'Payment details',
      HourlyRateTitle: 'Hourly Rate',
      NoHourlyRate: 'Hourly rate not set',
      HourlyCost: '$#{hourlyRate}',
      StripeIdTitle: 'Stripe ID',
      NoStripeId: 'Stripe ID does not exist',
      AutopayTitle: 'Autopay',
      Autopay: {
        Options: {
          'true': 'Enabled',
          'false': 'Disabled',
        },
      },
      BillingPeriodTitle: 'Billing period',
      BillingPeriod: {
        Options: {
          WEEKLY: 'Weekly',
          MONTHLY: 'Monthly',
        },
      },
    },
    Expense: {
      Amount: '$#{expenses}',
    },
    PaymentSlip: {
      Title: 'Payment slip',
    },
    Holidays: {
      Title: 'Statutory holidays',
      Description: 'Shifts on these dates are billed at 1.5×. This list is shared across all clients.',
      Year: 'Year',
      ColumnDate: 'Date',
      ColumnName: 'Name',
      ColumnSource: 'Source',
      SourceApiSync: 'https://canada-holidays.ca/api',
      SourceManual: 'Manual',
      AddDate: 'Date',
      AddName: 'Name',
      AddAction: 'Add',
      Remove: 'Remove',
      Empty: 'No statutory holidays for #{year}.',
      LoadError: 'Could not load holidays. Please try again.',
      AddError: 'Could not add the holiday. Please try again.',
      RemoveError: 'Could not remove the holiday. Please try again.',
    },
    StatHoliday: 'Stat Holiday 1.5×',
    StatHolidayNamed: 'Stat Holiday 1.5× • #{name}',
    Regenerate: {
      Title: 'Regenerate invoice',
      SelectDate: 'Week to regenerate',
      SelectDateMonthly: 'Month to regenerate',
      Action: 'Regenerate',
      Success: 'Invoice regenerated for week of #{date}.',
      InvoiceFailed: 'Slip regenerated for week of #{date}, but invoice creation failed: #{reason}.',
      NoShifts: 'No shifts found for week of #{date} — nothing to regenerate.',
      SuccessMonthly: 'Invoice regenerated for month of #{date}.',
      InvoiceFailedMonthly: 'Slip regenerated for month of #{date}, but invoice creation failed: #{reason}.',
      NoShiftsMonthly: 'No shifts found for month of #{date} — nothing to regenerate.',
      Error: 'Could not regenerate the invoice. Please try again.',
    },
    WeekOf: `Week of #{date} #{status}`,
    MonthOf: `Month of #{date} #{status}`,
    HoursDisplay: `#{hours} hrs`,
    CostDisplay: `$#{cost}`,
    WaitingConfirmation: 'Waiting confirmation',
    Complete: 'Complete',
    WorkSummary: {
      Title: 'Work summary',
      TotalHours: 'Total Hours',
      TotalCost: 'Total Cost',
      ConfirmedHours: 'Confirmed Hours',
      ConfirmedCost: 'Confirmed Cost',
      ShiftsScheduled: 'Shifts Scheduled',
      HoursScheduled: 'Hours Scheduled',
      ShiftsWorked: 'Shifts Worked',
      HoursWorkedTitle: 'Hours Worked',
      PayRate: 'Pay Rate',
      TotalExpenses: 'Total Expenses',
      TotalPay: 'Total Pay',
      WeeklyProgress: {
        Title: 'Weekly Progress',
        Owed: 'Owed',
        ShiftsCompleted: '#{workedShifts} of #{totalShifts} shifts completed',
        CompletionRate: '#{percentage}% completion rate',
        ShiftsCompletedWithRate: '#{workedShifts} of #{totalShifts} shifts completed • #{percentage}% completion rate',
      },
      HoursWorked: {
        Title: 'Hours worked',
        ShiftHeader: `#{date} - #{title}`,
        ClockIn: 'Clock-in',
        ClockOut: 'Clock-out',
        HourlyRate: '$#{hourlyRate}/hr',
      },
    },
  },
  CareviewSettings: {
    Title: 'Careview',
    Types: {
      FiveStar: {
        Title: 'Five star',
        Question: 'Question',
      },
      FreeFormText: {
        Title: 'Free form question',
        Question: 'Question',
        RequirdTitle: 'Required field?',
        Enabled: 'Yes',
        Disabled: 'No',
        FieldIsRequired: 'Field is required to processed',
      },
      YesNo: {
        Title: 'Yes/No',
        Question: 'Question',
        Followup: 'Follow-up',
        FollowupEnabledYes: `Will trigger follow-up on 'Yes' response`,
        FollowupEnabledQuestionYes: `Trigger a follow-up on 'Yes' response`,
        FollowupEnabledNo: `Will trigger follow-up on 'No' response`,
        FollowupEnabledQuestionNo: `Trigger a follow-up on 'No' response`,
        Enabled: 'Enabled',
        Disabled: 'Disabled',
      },
      MultipleChoice: {
        Title: 'Multiple choice',
        Question: 'Question',
        Options: 'Options',
        OptionNumber: 'Option #{number}',
        FollowupEnable: `(Will trigger follow-up on response)`,
        Followup: `Follow up on this response`,
        AddNew: `Add new option`,
      },
      Actions: {
        Delete: 'Delete',
        Cancel: 'Cancel',
        Save: 'Save',
      },
    },
    NewQuestion: {
      Action: 'Add new question',
      Title: 'Add new question',
      SelectType: 'Select type',
    },
    ResetQuestions: {
      Action: 'Reset questions to default',
      AreYouSure: 'Are you sure you want to reset the questions to default?',
    },
  },
  Career: {
    Title: 'Career',
  },
  Case: {
    Title: 'Cases',
  },
  FormSettings: {
    Title: 'Forms',
    FormsFeed: {
      Empty: 'No forms have been filled out yet.',
      Responses: 'Responses',
      SectionTitle: 'Form responses',
      Unanswered: 'No responses captured yet.',
      CarePlanSnapshot: 'Care plan snapshot',
      ForCaregivers: 'For caregivers',
      ForClient: 'For client',
      MatchLabel: 'Match: #{difficulty}',
      Schedule: {
        PreferredDays: 'Preferred Days: #{value}',
        PreferredTimes: 'Preferred Times: #{value}',
        VisitDuration: 'Visit Duration: #{value}',
        VisitLength: 'Visit Length: #{value}',
      },
    },
  },
  Careplan: {
    Title: 'Careplan',
    Update: 'Update',
    GeneralInformation: {
      Title: 'General information',
      ClientName: 'Client name',
      NoClientname: 'No client name',
      Address: 'Address',
      NoAddress: 'No address',
      Information: 'Information',
      NoClientInformation: 'No client information',
      Notes: 'Notes',
      NoNotes: 'No notes',
    },
    MedicalHistory: {
      Title: 'Medical history',
      Medications: 'Medications',
      NoMedications: 'No medications',
      Conditions: 'Conditions',
      NoConditions: 'No conditions',
    },
    CareRoutine: {
      Title: 'Care routine',
      ClientPreferences: 'Client preferences',
      NoPreferences: 'No preferences',
      Tasks: 'Daily Tasks',
      NoTasks: 'No tasks',
    },
    CaregiverRequirements: {
      Title: 'Caregiver requirements (Admin only)',
      CareplanSummary: 'Careplan summary',
      NoCareplanSummary: 'No careplan summary',
      ScheduleRequirement: 'Schedule requirement',
      NoScheduleRequirement: 'No schedule requirement',
      MatchDifficulty: 'Match difficulty',
      NoMatchDifficulty: 'Not analyzed yet',
      MatchDifficultyOptions: {
        EASY: 'Easy',
        MEDIUM: 'Medium',
        HARD: 'Hard',
      },
      RequirementChips: 'Requirement tags',
      RequirementChipPlaceholder: 'Add a requirement',
      NoRequirementChips: 'No requirements added',
    },
    ReplacementPreference: {
      Title: 'Replacement preference',
      Field: 'Replacement preference',
      Options: {
        NONE: 'NOT SET',
        FIND_REPLACEMENT: 'Find Replacement Caregiver',
        SKIP_VISIT: 'Skip Visit',
      },
    },
  },
  Tasks: {
    Title: 'All Tasks',
    OverviewTitle: 'Today\'s Tasks',
    Filters: {
      All: 'All',
    },
    Sections: {
      Current: 'Current',
      Next: 'Next',
      Overdue: 'Overdue',
      DueToday: 'Due Today',
      DueLater: 'Due Later',
      Unassigned: 'Unassigned',
      Completed: 'Completed',
    },
    TabLabels: {
      Description: 'Description',
      DueDate: 'Due',
      CreateTask: 'Create Task',
    },
    Type: {
      Common: {
        TitleField: 'Title',
        TitlePlaceholder: 'Enter task name',
        DescriptionField: 'Description',
        DescriptionPlaceholder: 'Type @, #, $, or ! to add fields',
        DueDateField: 'Due Date',
        Commands: {
          Title: 'Available Commands:',
          Assign: {
            Cmd: '@',
            HelperTxt: 'Assign to someone',
          },
          Caregiver: {
            Cmd: '#',
            HelperTxt: 'Link to caregiver',
          },
          Type: {
            Cmd: '!',
            HelperTxt: 'Set task type',
          },
          Client: {
            Cmd: '$',
            HelperTxt: 'Link to client',
          },
        },
      },
      AddTask: {
        Title: 'Add Task',
        Submit: 'Create Task',
      },
      EditTask: {
        Title: 'Edit Task',
        Submit: 'Save Changes',
      },
    },
    Chips: {
      Type: 'Type',
      Assignee: 'Assignee',
      Connections: {
        Title: 'Connections',
        client: 'Client',
        caregiver: 'Caregiver',
      },
    },
    StatusOptions: {
      OPEN: 'Open',
      COMPLETE: 'Complete',
    },
    Generic: {
      AddField: 'Add Field',
    },
  },
  Playbooks: {
    Title: 'Active Playbooks',
    Empty: 'No active playbooks.',
    DeleteAction: 'Delete playbook and all associated tasks',
    RedirectAction: 'View playbook',
    ViewAllTasks: 'View all playbook tasks',
  },
  ChangeStatusDialog: {
    Title: 'Change status',
    Status: 'Status',
    ReasonTitle: 'Add reason for status change',
    ReasonPrompt: 'Why was this client moved to #{status}?',
    Reason: 'Reason',
    ReasonPlaceholder: 'Enter the reason for this status change',
  },
  ChangeName: {
    Title: 'Change name',
    Name: 'Name',
  },
};
